import payment from './payment';
import printer from './printer';
import scale from './scale';
import customerDisplay from './customerDisplay';
import cashDrawer from './cashDrawer';
import idCard from './idCard';

export default [payment, printer, scale, customerDisplay, cashDrawer, idCard];
